/*
 * @Author: wb_guochuang wb_guochuang@kuaishou.com
 * @Date: 2022-07-12 01:13:52
 * @LastEditors: wb_guochuang wb_guochuang@kuaishou.com
 * @LastEditTime: 2022-07-27 21:55:18
 * @FilePath: \ancient-book\src\api\fileContrast.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'

// 通过任务编号获取版本对比信息、版本调阅的信息
export function getStudyDrop(data) {
  return request({
    url: `/version/metas/${data.taskId}`,
    method: 'get',
    data,
  })
}

// 标注图片
export function getUpdatepic(data) {
  return request({
    url: '/version/save/metatype',
    method: 'post',
    data,
  })
}

// （个人）提交任务workStatus = 6 （个人）取消任务12 （审核）通过任务7 （审核）未通过8
export function addWork(data) {
  return request({
    url: '/work/addWork',
    method: 'post',
    data,
  })
}

// （审核）返修
export function updateFlowDays(data) {
  return request({
    url: '/flow/updateFlowDays',
    method: 'post',
    data,
  })
}

//（个人）判断是否可提交版本对比任务
export function versionCheck(data) {
  return request({
    url: `/version/check/${data.taskId}`,
    method: 'get',
    data,
  })
}

// 版本对比按钮是否显示
export function versionButtons(data) {
  return request({
    url: `/version/buttons/${data.taskId}`,
    method: 'get',
    data,
  })
}

// 获取只读的
export function getVersionJiaoben(data) {
  return request({
    url: `/version/jiaoben/${data.taskId}`,
    method: 'get',
    data,
  })
}
